<div>

  <div style="display: grid; grid-template-columns: 1fr 40px;">
    <div style="height: 400px; overflow-y: scroll;">
      <div [style.height.px]="chartHeight">
        <canvas id="graph-canvas"></canvas>
      </div>
    </div>
    <div>
      <button class="btn" type="button" [disabled]="!enableZoomInChart" (click)="zoomInChart()">
        <i class="fa fa-plus"></i>
      </button>
      <br />
      <button class="btn" type="button" [disabled]="!enableZoomOutChart" (click)="zoomOutChart()">
        <i class="fa fa-minus"></i>
      </button>
    </div>
  </div>

  <p-table class="snmpif-history-table history-table" [value]="entries" [scrollable]="true" scrollHeight="calc(380px - 49px)"
    [resizableColumns]="true">
    <ng-template pTemplate="header">
      <tr>
        <th pResizableColumn>Device Name</th>
        <th pResizableColumn>IP Address</th>
        <th pResizableColumn>IF Name</th>
        <th pResizableColumn>Timestamp</th>
        <th pResizableColumn>OperStatus</th>
        <th pResizableColumn>IN Octets (MBPS)</th>
        <th pResizableColumn>IN Utilization (%)</th>
        <th pResizableColumn>OUT Octets (MBPS)</th>
        <th pResizableColumn>OUT Utilization (%)</th>
        <th pResizableColumn>Error</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
      <tr>
        @if (rowGroupMetadata[rowData.groupKey].index === rowIndex) {
          <td
            [attr.rowspan]="rowGroupMetadata[rowData.groupKey].size"
            class="history-entry">
            <div class="uv-table-value">{{rowData.deviceName}}</div>
          </td>
        }
        @if (rowGroupMetadata[rowData.groupKey].index === rowIndex) {
          <td
            [attr.rowspan]="rowGroupMetadata[rowData.groupKey].size"
            class="history-entry">
            <div class="uv-table-value">{{rowData.ipAddress}}</div>
          </td>
        }
        @if (rowGroupMetadata[rowData.groupKey].index === rowIndex) {
          <td
            [attr.rowspan]="rowGroupMetadata[rowData.groupKey].size"
            class="history-entry">
            <div class="uv-table-value">{{rowData.ifName}}</div>
          </td>
        }
        <td pTooltip="{{formatDateHm(rowData.timestamp)}}">
          <div class="uv-table-value">{{formatDateHm(rowData.timestamp)}}</div>
        </td>
        <td>
          <div class="uv-table-value">{{rowData.operStatus}}</div>
        </td>
        <td>
          <div class="uv-table-value">{{rowData.inBytes}}</div>
        </td>
        <td>
          <div class="uv-table-value">{{rowData.inUtilization}}</div>
        </td>
        <td>
          <div class="uv-table-value">{{rowData.outBytes}}</div>
        </td>
        <td>
          <div class="uv-table-value">{{rowData.outUtilization}}</div>
        </td>
        <td pTooltip="{{rowData.error}}">
          <div class="uv-table-value">{{rowData.error}}</div>
        </td>
      </tr>
    </ng-template>
  </p-table>

</div>
